import { render, staticRenderFns } from "./changeProduct.vue?vue&type=template&id=1832a222&scoped=true"
import script from "./changeProduct.vue?vue&type=script&lang=js"
export * from "./changeProduct.vue?vue&type=script&lang=js"
import style0 from "./changeProduct.vue?vue&type=style&index=0&id=1832a222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832a222",
  null
  
)

export default component.exports